import { render, staticRenderFns } from "./issues-report.vue?vue&type=template&id=242f6d30&lang=pug&"
import script from "./issues-report.vue?vue&type=script&lang=ts&"
export * from "./issues-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports